import React, { useContext, useEffect, useRef } from "react";
import { CgChevronLeftR, CgChevronRightR } from "react-icons/cg";
import { StateContext } from "../Context/Context";
import { allProjects } from "./projectConfig";
import { initial, rightClick, leftClick, display } from "../Animation";

export default function Details({ project, index, first }) {
  // eslint-disable-next-line
  const { state, setState } = useContext(StateContext);

  const itemEls = useRef([]);

  useEffect(() => {
    initial(first.current.children[state.num]);
  });
  useEffect(() => {
    display([...itemEls.current]);
  }, []);

  const nextSlide = () => {
    if (index !== allProjects.length - 1) {
      rightClick(
        first.current.children[index],
        first.current.children[index + 1]
      );
    } else {
      return;
    }
  };
  const prevSlide = () => {
    if (index !== 0) {
      // setState(index - 1);
      leftClick(
        first.current.children[index],
        first.current.children[index - 1]
      );
    } else {
      return;
    }
  };

  let prev;
  let next;
  if (index !== allProjects.length - 1) {
    next = (
      <>
        <small>Next</small>
        <p>
          <strong>{allProjects[index + 1].title}</strong>
        </p>
      </>
    );
  } else {
    next = "";
  }
  if (index !== 0) {
    prev = (
      <>
        <small>Previous</small>
        <p>
          <strong>{allProjects[index - 1].title}</strong>
        </p>
      </>
    );
  } else {
    prev = "";
  }

  return (
    <div className="whole min-h-[50vh] md:min-h-[60vh] md:mx-[10%] flex flex-col justify-between">
      <div className="content flex-1 h-full">
        <div className="det self-center">
          <h1 className="text-2xl md:text-3xl">
            <strong>{project.title}</strong>
          </h1>
          <p className="text-black/70 dark:text-white/70 text-sm md:text-base my-1">
            {project.description}
          </p>
          <div className="d-flex justify-content-between my-4">
            <h5 className="text-black/70 dark:text-white/70">
              <strong>
                <span className="color-pink">Role: </span>
              </strong>{" "}
              {project.role}
            </h5>
            <h5 className="text-black/70 dark:text-white/70">
              <strong>
                <span className="color-pink">Year: </span>
              </strong>{" "}
              {project.year}
            </h5>
          </div>
          {/* <h4 className="color-pink mb-2">
            <strong>Links:</strong>
          </h4> */}
          <div className="d-flex justify-content-around gap-2">
            {/* <a href={project.links[0]} target="_blank" rel="noreferrer">
              <div className="btn-hover">
                <button className="btnCN">
                  <span className="span1"></span>
                  <span className="span2"></span>Github
                </button>
              </div>
            </a> */}
            <a href={project.links[1]} target="_blank" rel="noreferrer">
              <div className="btn-hover">
                <button className="btnCN">
                  <span className="span1"></span>
                  <span className="span2"></span>Link
                </button>
              </div>
            </a>
          </div>
        </div>
        <div className="img-case">
          {project.images.map((image, index) => (
            <img
              className="img-fluid"
              src={image}
              alt=""
              ref={(e) => itemEls.current.push(e)}
            />
          ))}
          {/* <img
            className="img-fluid"
            src={project.images[0]}
            alt=""
            ref={(e) => (pic = e)}
          />
          <img
            className="img-fluid"
            src={project.images[1]}
            alt=""
            ref={(e) => (pic2 = e)}
          />
          <img
            className="img-fluid"
            src={project.images[2]}
            alt=""
            ref={(e) => (pic3 = e)}
          /> */}
        </div>
      </div>
      <div className="slide">
        <div className="prev d-flex justify-content-between align-items-center !bg-black/80">
          <CgChevronLeftR
            className="color-pink"
            size="35px"
            style={{ cursor: "pointer" }}
            onClick={prevSlide}
          />
          <div>{prev}</div>
        </div>
        <div className="next d-flex justify-content-between align-items-center !bg-secondary/40">
          <div>{next}</div>
          <CgChevronRightR
            className="color-pink"
            size="35px"
            style={{ cursor: "pointer" }}
            onClick={nextSlide}
          />
        </div>
      </div>
    </div>
  );
}
